package dev.lingvo.shared.screenshots.frames

import dev.lingvo.shared.DeviceClass
import dev.lingvo.shared.screenshots.doc.FrameKind

/** Uses current display classes rather than obsolete inch-size identifiers; first entry is the default. */
internal fun offeredFrames(device: DeviceClass): List<FrameKind> = when (device) {
    DeviceClass.IPHONE_DI_LARGE, DeviceClass.IPHONE_DI_MEDIUM -> listOf(FrameKind.PHONE_ISLAND, FrameKind.PHONE_NOTCH, FrameKind.NONE)
    DeviceClass.IPHONE_FACE_ID_LARGE, DeviceClass.IPHONE_FACE_ID_MEDIUM -> listOf(FrameKind.PHONE_NOTCH, FrameKind.PHONE_ISLAND, FrameKind.NONE)
    DeviceClass.IPHONE_HOME_BUTTON -> listOf(FrameKind.PHONE_FLAT, FrameKind.NONE)
    DeviceClass.IPHONE_DUO -> listOf(FrameKind.NONE, FrameKind.FOLDABLE_OPEN)
    DeviceClass.IPAD_13, DeviceClass.IPAD_11 -> listOf(FrameKind.TABLET_UNIFORM, FrameKind.NONE)
    DeviceClass.MAC -> listOf(FrameKind.LAPTOP, FrameKind.BROWSER, FrameKind.NONE)
    DeviceClass.PLAY_PHONE -> listOf(FrameKind.PHONE_PUNCH_HOLE, FrameKind.PHONE_FLAT, FrameKind.PHONE_ISLAND, FrameKind.NONE)
    DeviceClass.PLAY_TABLET_7, DeviceClass.PLAY_TABLET_10 -> listOf(FrameKind.TABLET_ANDROID, FrameKind.FOLDABLE_OPEN, FrameKind.NONE)
    DeviceClass.PLAY_FEATURE_GRAPHIC -> listOf(FrameKind.NONE)
    DeviceClass.PLAY_WEAR -> listOf(FrameKind.WATCH_ROUND, FrameKind.NONE)
}
